import {
  LogisticElementModel,
  CounterpartModel,
  OperationBalanceConfiguration,
  BuyAndSellModel,
  AddBuyAndSellModel,
  AddMassiveBuyAndSellModel
} from './buyandsell.model'
import {
  Operacion,
  ElementoLogistico,
  Sujeto,
  OperacionPost,
  ConfigOperacionBalance,
  OperacionPatch,
  OperacionDelete
} from '../../api/oData/model'

import {
  EnumDispatchType,
  EnumEstadoOperacion,
  EnumSubTipoElemLog,
  EnumTipoOperacion,
  EnumOperationState,
  EnumEstadoOperacionConciliar,
  EnumTipoElemLog,
  EnumEstadoOperacionBuyAndSell,
  EnumSubtipoSujeto
} from '../../api/oData/enums'

import i18n from '../../i18n'
import { enumKeyToValue, enumValueToKey } from '../../helpers'
import { SelectOption } from '@globaleris/ui.library'
import {
  canCancel,
  canDelete,
  canEdit,
  canSend,
  getGlobalActionsConfiguration
} from './buyandsell.service'
import { getActiveBalanceZone, getActiveCompany } from '../../redux'
import { BatchRequest, BatchRequestItem, DispatchRequest, TradeListItem } from '../../api'
import moment from 'moment'

export const buyAndSellListItemMapperApiToVM = (item: Operacion): BuyAndSellModel => {
  return (
    item && {
      id: item.id,
      date: item.fechaOperacion,
      operationType: enumKeyToValue(EnumTipoOperacion, item.tipoOperacion),
      translatedType: item.tipoOperacion
        ? i18n.t(`enums:EnumTipoOperacion.${item.tipoOperacion}`)
        : '',
      logisticElement: buyAndSellLogisticElementMapperApiToVM(item.elementoLogistico),
      quantity: item.cantidad,
      // price: item.precio,
      counterpart: buyAndSellCounterpartMapperApiToVM(item.contraparte),
      codTrade: item.posicion?.trade?.codTrade,
      codPosition: item.posicion?.codPosicion,
      sent: enumKeyToValue(EnumEstadoOperacionConciliar, item.estadoTSO),
      sentDay: item.cantidadEnvio,
      quantityTSO: item.cantidadTSO,
      sentQuantity: item.cantidadEnvio,
      stateTSO: enumKeyToValue(EnumEstadoOperacionConciliar, item.estadoTSO),
      state: enumKeyToValue(EnumOperationState, item.estadoOperacion),
      stateBuyAndSell: [GetStateBuyAndSell(item)], // It's a single value but we want to use it as a MULTISELECT in the table so people can filter by multiple values
      registerDate: item.fechaAlta,
      codShip: item.codViajeTSO,
      actionsConfiguration: getGlobalActionsConfiguration(),
      canSend: canSend(
        enumKeyToValue(EnumOperationState, item.estadoOperacion),
        enumKeyToValue(EnumEstadoOperacionConciliar, item.estadoTSO),
        item.fechaOperacion,
        enumKeyToValue(EnumTipoElemLog, item.elementoLogistico.tipoElementoLogistico),
        item.cantidad,
        item.cantidadTSO
      ),
      canCancel: canCancel(
        enumKeyToValue(EnumOperationState, item.estadoOperacion),
        item.fechaOperacion,
        enumKeyToValue(EnumSubtipoSujeto, item.contraparte.subtipoSujeto)
      ),
      canEdit: canEdit(
        item.fechaOperacion,
        enumKeyToValue(EnumSubtipoSujeto, item.contraparte.subtipoSujeto)
      ),
      canDelete: canDelete(
        enumKeyToValue(EnumOperationState, item.estadoOperacion),
        item.fechaOperacion,
        enumKeyToValue(EnumSubtipoSujeto, item.contraparte.subtipoSujeto)
      )
    }
  )
}

export const buyAndSellListItemsMapperApiToVM = (items: Operacion[]): BuyAndSellModel[] => {
  return items && items.map(buyAndSellListItemMapperApiToVM)
}

export const buyAndSellLogisticElementMapperApiToVM = (
  logisticElement: ElementoLogistico
): LogisticElementModel => {
  return (
    logisticElement && {
      id: logisticElement.id,
      description: logisticElement.descripcion,
      type: enumKeyToValue(EnumTipoElemLog, logisticElement.tipoElementoLogistico)
    }
  )
}

export const buyAndSellCounterpartMapperApiToVM = (counterpart: Sujeto): CounterpartModel =>
  counterpart && { id: counterpart.id, description: counterpart.deSujeto }

export const GetStateBuyAndSell = (item: Operacion): EnumEstadoOperacionBuyAndSell => {
  const stateOperacion = enumKeyToValue(EnumOperationState, item.estadoOperacion)
  const stateOperacionTso = enumKeyToValue(EnumEstadoOperacionConciliar, item.estadoTSO)

  return stateOperacion == EnumOperationState.Borrador &&
    stateOperacionTso == EnumEstadoOperacionConciliar.NoConciliado
    ? EnumEstadoOperacionBuyAndSell.Borrador
    : stateOperacion == EnumOperationState.Rechazado
      ? EnumEstadoOperacionBuyAndSell.Rechazado
      : stateOperacion == EnumOperationState.DP
        ? EnumEstadoOperacionBuyAndSell.DP
        : stateOperacion == EnumOperationState.FD
          ? EnumEstadoOperacionBuyAndSell.FD
          : stateOperacion == EnumOperationState.FP
            ? EnumEstadoOperacionBuyAndSell.FP
            : stateOperacion == EnumOperationState.PendienteRenvio
              ? EnumEstadoOperacionBuyAndSell.PendienteRenvio
              : stateOperacionTso == EnumEstadoOperacionConciliar.PdteFormalizacion
                ? EnumEstadoOperacionBuyAndSell.PdteFormalizacion
                : stateOperacionTso == EnumEstadoOperacionConciliar.Formalizado
                  ? EnumEstadoOperacionBuyAndSell.Formalizado
                  : stateOperacionTso == EnumEstadoOperacionConciliar.FormalizadoModificacion
                    ? EnumEstadoOperacionBuyAndSell.FormalizadoModificacion
                    : stateOperacionTso == EnumEstadoOperacionConciliar.FormalizadoAnulacion
                      ? EnumEstadoOperacionBuyAndSell.FormalizadoAnulacion
                      : stateOperacionTso == EnumEstadoOperacionConciliar.Anulado
                        ? EnumEstadoOperacionBuyAndSell.Anulado
                        : stateOperacionTso == EnumEstadoOperacionConciliar.NoConciliado
                          ? EnumEstadoOperacionBuyAndSell.NoConciliado
                          : stateOperacionTso == EnumEstadoOperacionConciliar.PdteConciliar
                            ? EnumEstadoOperacionBuyAndSell.PdteConciliar
                            : stateOperacionTso == EnumEstadoOperacionConciliar.Eliminado
                              ? EnumEstadoOperacionBuyAndSell.Eliminado
                              : EnumEstadoOperacionBuyAndSell.Rechazado
}

export const buyAndSellMapperToAPI_POST = (item: BuyAndSellModel): OperacionPost => {
  return (
    item && {
      tipoOperacion: enumValueToKey(EnumTipoOperacion, item.operationType),
      estado: enumValueToKey(EnumEstadoOperacion, EnumEstadoOperacion.Repartido),
      estadoOperacion: enumValueToKey(EnumOperationState, EnumOperationState.Borrador),
      fechaOperacion: moment(item.date).format('YYYY-MM-DD'),
      cantidad: item.quantity,
      zonaBalance: getActiveBalanceZone()?.code,
      codViajeTSO: item.codShip,
      // precio: item.price,
      //fee: +item.fee,
      elementoLogistico: {
        '@odata.id': 'elementoslogisticos(' + item.logisticElement.description + ')'
      },
      empresa: {
        '@odata.id': 'empresa(' + getActiveCompany()?.id + ')'
      },
      contraparte: {
        '@odata.id': 'sujetos(' + item.counterpart + ')'
      }
    }
  )
}

export const buyAndSellMapperCancelToAPI_PATCH = (item: BuyAndSellModel): OperacionPatch => {
  return (
    item && {
      id: item.id,
      tipoOperacion: enumValueToKey(EnumTipoOperacion, item.operationType),
      estadoOperacion: enumValueToKey(EnumOperationState, EnumOperationState.PendienteRenvio),
      cantidad: 0,
      idEmpresa: getActiveCompany()?.id,
    }
  )
}

export const buyAndSellMapperToAPI_PATCH = (item: BuyAndSellModel): OperacionPatch => {
  return (
    item && {
      id: item.id,
      tipoOperacion: enumValueToKey(EnumTipoOperacion, item.operationType),
      fechaOperacion: moment(item.date).format('YYYY-MM-DD'),
      cantidad: item.quantity,
      // precio: item.price,
      estadoOperacion:
        item.state === EnumOperationState.Enviada ||
        item.state === EnumOperationState.Rechazado ||
        item.state === EnumOperationState.PendienteRenvio
          ? enumValueToKey(EnumOperationState, EnumOperationState.PendienteRenvio)
          : enumValueToKey(EnumOperationState, item.state),
      codViajeTSO: item.codShip,
      idElemLogistico: item.logisticElement.id,
      idContraparte: item.counterpart.id,
      zonaBalance: getActiveBalanceZone()?.code,
      idEmpresa: getActiveCompany()?.id,
      // elementoLogistico: {
      //   '@odata.id': 'elementoslogisticos(' + item.logisticElement.id + ')'
      // }
    }
  )
}

export const buyAndSellMapperToAPI_DELETE = (item: BuyAndSellModel): OperacionDelete => {
  return (
    item && {
      id: item.id,
      tipoOperacion: enumValueToKey(EnumTipoOperacion, item.operationType)
    }
  )
}

export const buyAndSellSendMapperToAPI_POST = (items: any, idCompany: number): DispatchRequest => {
  return (
    items && {
      dispatchType: enumValueToKey(EnumDispatchType, EnumDispatchType.Nominacion),
      companyID: idCompany,
      operations: items.map((item: BuyAndSellModel) => {
        if (item?.counterpart?.id !== 168 && item.logisticElement.type !== EnumTipoElemLog.Punto) {
          // No se puede enviar para MIBGAS
          return {
            id: item.id,
            operationType: enumValueToKey(EnumTipoOperacion, item.operationType),
            balanceZone: getActiveBalanceZone()?.code!
          }
        } else {
          return {}
        }
      })
    }
  )
}

export const operationBalanceConfigMapperAPItoModel = (
  item: ConfigOperacionBalance
): OperationBalanceConfiguration => {
  return (
    item && {
      operationType: enumKeyToValue(EnumTipoOperacion, item.tipoOperacion),
      logisticElementSubType: enumKeyToValue(EnumSubTipoElemLog, item.subtipoElementoLogistico)
    }
  )
}

export const operationsBalanceConfigMapperAPItoModel = (
  items: ConfigOperacionBalance[]
): OperationBalanceConfiguration[] => {
  return items && items.map(operationBalanceConfigMapperAPItoModel)
}

export const logisticElementsMapperToDropDown = (items: ElementoLogistico[]): SelectOption[] => {
  return items && items.map(logisticElementMapperToDropDown)
}

export const logisticElementMapperToDropDown = (item: ElementoLogistico): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.descripcion || ''
    }
  )
}

export const counterpartsMapperToDropDown = (items: Sujeto[]): SelectOption[] => {
  return items && items.map(counterpartMapperToDropDown)
}

export const counterpartMapperToDropDown = (item: Sujeto): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.deSujeto || ''
    }
  )
}

export const buyAndSellToCancelBatchRequest = (items: BuyAndSellModel[]): BatchRequest => {
  return (
    items && {
      requests: items.map(buyAndSellToCancelBatchRequestItem)
    }
  )
}

export const buyAndSellToCancelBatchRequestItem = (item: BuyAndSellModel): BatchRequestItem => {
  return (
    item && {
      id: `Operación de compraventa con trade: ${item.codTrade} - ${item.codPosition} - ${item.id}`,
      method: 'PATCH',
      atomicityGroup: 'ag1',
      url: `/oData/Operaciones(${item.id}, '${enumValueToKey(
        EnumTipoOperacion,
        item.operationType
      )}')`,
      headers: {
        'OData-Version': '4.01',
        'Content-Type': 'application/json;odata.metadata=minimal',
        Accept: 'application/json;odata.metadata=minimal'
      },
      body: {
        id: item.id,
        tipoOperacion: enumValueToKey(EnumTipoOperacion, item.operationType),
        estadoOperacion: enumValueToKey(EnumOperationState, EnumOperationState.PendienteRenvio),
        cantidad: 0
      }
    }
  )
}

export const buyAndSellToDeleteBatchRequest = (items: BuyAndSellModel[]): BatchRequest => {
  return (
    items && {
      requests: items.map(buyAndSellToDeleteBatchRequestItem)
    }
  )
}

export const buyAndSellToDeleteBatchRequestItem = (item: BuyAndSellModel): BatchRequestItem => {
  return (
    item && {
      id: `Operación de compraventa con trade: ${item.codTrade} - ${item.codPosition} - ${item.id}`,
      method: 'DELETE',
      atomicityGroup: 'ag1',
      url: `/oData/Operaciones(${item.id}, '${enumValueToKey(
        EnumTipoOperacion,
        item.operationType
      )}')`,
      headers: {
        'OData-Version': '4.01',
        'Content-Type': 'application/json;odata.metadata=minimal',
        Accept: 'application/json;odata.metadata=minimal'
      }
    }
  )
}

// export const buyAndSellToAddBatchRequest = (
//   item: AddMassiveBuyAndSellModel,
//   companyId: number,
//   balanceZoneCode: string
// ): BatchRequest => {
//   let items: AddBuyAndSellModel[] = []
//   for (
//     var current = moment(item.startDate);
//     moment(current).isSameOrBefore(moment(item.endDate), 'day');
//     current = current.add(1, 'day')
//   ) {
//     items.push({
//       date: current.toDate(),
//       operationType: item.operationType.id,
//       quantity: item.quantity,
//       stateTSO: item.stateTSO,
//       logisticElement: item.logisticElement,
//       counterpart: item.counterpart,
//       companyId: companyId,
//       balanceZoneCode: balanceZoneCode
//     })
//   }
//   return (
//     items && {
//       requests: items.map(buyAndSellToAddBatchRequestItem)
//     }
//   )
// }

export const buyAndSellToAddBatchRequestItem = (item: AddBuyAndSellModel): BatchRequestItem => {
  return (
    item && {
      id: item.date.toLocaleDateString(),
      method: 'POST',
      url: `/oData/Operaciones`,
      atomicityGroup: 'ag1',
      headers: {
        'OData-Version': '4.01',
        'Content-Type': 'application/json;odata.metadata=minimal',
        Accept: 'application/json;odata.metadata=minimal'
      },
      body: {
        fechaOperacion: item.date,
        tipoOperacion: enumKeyToValue(EnumTipoOperacion, item.operationType),
        cantidad: item.quantity,
        estadoOperacion: enumKeyToValue(EnumOperationState, item.stateTSO),
        zonaBalance: item.balanceZoneCode,
        elementoLogistico: {
          '@odata.id': 'elementoslogisticos(' + item.logisticElement.description + ')'
        },
        empresa: {
          '@odata.id': 'empresa(' + item.companyId + ')'
        },
        contraparte: {
          '@odata.id': 'sujetos(' + item.counterpart + ')'
        }
      }
    }
  )
}

export const tradeListItemsToSelectOption = (
  tradeList: TradeListItem[] | undefined
): SelectOption[] => {
  return tradeList ? tradeList.map(trade => tradeListItemToSelectOption(trade)) : []
}

const tradeListItemToSelectOption = (trade: TradeListItem): SelectOption => {
  return {
    value: trade.id,
    label: trade.codTrade
  }
}
